import "../styles/app.scss";
import "./_images";

__webpack_public_path__ = document.currentScript.src.replace(
  /\/scripts\/[^/]+$/,
  "/"
);
import OpenSearchBar from "./components/OpenSearchBar";
import Marquee from "./components/Marquee";
import BackToTop from "./components/BackToTop";
import {SignUp} from "./components/SignUp";
import {initSignupImageUpload} from "./components/SignupImageUpload";
import DonationEquipmentDirectCheckout from "./components/DonationEquipmentDirectCheckout";
import DonationOpportunitiesSlider from "./components/DonationOpportunitiesSlider";
import HomeToolkitSlider from "./components/HomeToolkitSlider";
import { CSSVariables } from "./Components/CSSVariables";
import { MyAccountStats } from "./Components/MyAccountStats";
import { MyAccountParticipantDashboard } from "./Components/MyAccountParticipantDashboard";
import { MyAccountSettings } from "./Components/MyAccountSettings";
import { MyAccountNavigation } from "./Components/MyAccountNavigation";
import { MyAccountDonorsEmailModal } from "./Components/MyAccountDonorsEmailModal";
import { MyAccountCampaignEdit } from "./MyAccount/MyAccountCampaignEdit";
import { CampaignMessageMediaUpload } from "@levcharity/resources/scripts/components/CampaignMessageMediaUpload.js";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    new CSSVariables();
    new OpenSearchBar();
    Marquee();
    BackToTop();
    new SignUp();
    initSignupImageUpload();
    DonationEquipmentDirectCheckout();
    DonationOpportunitiesSlider();
    HomeToolkitSlider();

    const pathname = window.location.pathname.replace(/^\/+|\/+$/g, "");
    const hasMyAccountStats =
      document.querySelector(".accounts_bar") ||
      document.querySelector(".custom_bar_chart_wrapper");
    const isMyAccountStatsPath =
      pathname.endsWith("my-campaign") ||
      pathname.endsWith("my-team") ||
      ["my-account/my-campaign", "my-account/my-team"].includes(pathname);

    if (hasMyAccountStats && isMyAccountStatsPath) {
      new MyAccountStats();
    }
    new MyAccountParticipantDashboard();
    new MyAccountNavigation();
    new MyAccountDonorsEmailModal();
    new MyAccountSettings();
    new MyAccountCampaignEdit();
    new CampaignMessageMediaUpload();
  },
  false,
);
